"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ellipsis = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Box_1 = require("../Box");
var Container = (0, styled_components_1.default)(Box_1.Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var Dot = (0, styled_components_1.default)(Box_1.Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  background-color: currentColor;\n  border-radius: 50%;\n"], ["\n  width: ", ";\n  height: ", ";\n  background-color: currentColor;\n  border-radius: 50%;\n"])), function (_a) {
    var size = _a.size;
    return size;
}, function (_a) {
    var size = _a.size;
    return size;
});
var Ellipsis = function (_a) {
    var _b = _a.orientation, orientation = _b === void 0 ? "horizontal" : _b, _c = _a.size, size = _c === void 0 ? "3px" : _c, _d = _a.spacing, spacing = _d === void 0 ? 1 : _d, rest = __rest(_a, ["orientation", "size", "spacing"]);
    return (react_1.default.createElement(Container, __assign({ flexDirection: orientation === "horizontal" ? "row" : "column" }, rest),
        react_1.default.createElement(Dot, { size: size }),
        react_1.default.createElement(Dot, __assign({ size: size }, (orientation === "horizontal" ? { mx: spacing } : { my: spacing }))),
        react_1.default.createElement(Dot, { size: size })));
};
exports.Ellipsis = Ellipsis;
exports.Ellipsis.displayName = "Ellipsis";
var templateObject_1, templateObject_2;
//# sourceMappingURL=Ellipsis.js.map